// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const CheckoutStep = {
  Visit: {
    Name: 'Visit',
    Value: 'visit',
  },
  ItemAdded: {
    Name: 'Item Added',
    Value: 'item-added',
  },
  Contact: {
    Name: 'Contact',
    Value: 'contact',
  },
  Message: {
    Name: 'Message',
    Value: 'message',
  },
  Delivery: {
    Name: 'Delivery',
    Value: 'delivery',
  },
  Payment: {
    Name: 'Payment',
    Value: 'payment',
  },
  Review: {
    Name: 'Review',
    Value: 'review',
  },
  ProcessPayment: {
    Name: 'Process Payment',
    Value: 'process-payment',
  },
  Complete: {
    Name: 'Complete',
    Value: 'complete',
  },
} as const

export type CheckoutStepValue = (typeof CheckoutStep)[keyof typeof CheckoutStep]['Value']
